(function () {
  var node = document.querySelector('[data-ck-360]');
  if (!node) return;
  var spins, url, k, wrap, el;
  try { spins = JSON.parse(node.textContent); } catch (e) { return; }
  for (k in spins) {
    if (String(spins[k]).indexOf('.spin') !== -1) { url = spins[k]; break; }
  }
  if (!url) return;
  var hero = document.querySelector('.pdp__main-img');
  if (!hero) return;
  var grid = document.querySelector('[data-thumb-grid]');
  var tab = null;
  if (grid) {
    tab = document.createElement('button');
    tab.type = 'button';
    tab.className = 'pdp-thumb-grid__item ck-360-thumb active';
    tab.setAttribute('aria-label', '360 view');
    tab.innerHTML = '<img alt="" src="' + node.getAttribute('data-thumb') + '" width="72" height="72">';
    var on = grid.querySelector('.active');
    if (on) on.classList.remove('active');
    grid.insertBefore(tab, grid.firstChild);
  }
  function kill() {
    if (!wrap) return;
    try { window.Sirv && Sirv.stop(el); } catch (e) {}
    wrap.remove();
    wrap = el = null;
    if (tab) tab.classList.remove('active');
  }
  function mount() {
    if (wrap) return;
    wrap = document.createElement('div');
    wrap.className = 'ck-360';
    el = document.createElement('div');
    el.className = 'Sirv';
    el.setAttribute('data-src', url);
    wrap.appendChild(el);
    hero.appendChild(wrap);
    try { window.Sirv && Sirv.start(el); } catch (e) {}
    if (tab) tab.classList.add('active');
  }
  mount();
  document.addEventListener('click', function (e) {
    if (e.target.closest('.pdp__main-img')) return;
    if (tab && tab.contains(e.target)) { mount(); return; }
    kill();
  });
  document.addEventListener('ck:color', function () {
    kill();
    if (tab) tab.remove();
  }, { once: true });
})();
